<template>
    <fieldset>
        <h2 v-if="!IsLoading && Errors === null">Download Bulk Enrolment Template</h2>
        <p v-if="!IsLoading && Errors === null">
            Download Spreadsheet
            <a download href="/api/BulkRegistration">here</a>
        </p>
        <h2 v-if="Report === null">Upload Bulk Enrolment Spreadsheet</h2>
        <p v-if="IsLoading">
            <loading-indicator /> Loading...
        </p>
        <p v-if="!IsLoading && (Errors === null || Errors.length > 0)">
            Upload Spreadsheet
            <input type="file" @change="FileAdded($event.target.files)" accept=".xlsx" />
        </p>
        <h3 v-if="!IsLoading && Errors !== null && Errors.length > 0">Errors</h3>
        <ul v-if="!IsLoading && Errors !== null && Errors.length > 0">
            <li v-for="(error, errorIndex) in Errors" :key="errorIndex">{{error}}</li>
        </ul>
        <h3 v-if="!IsLoading && Warnings !== null && Warnings.length > 0">Warnings</h3>
        <ul v-if="!IsLoading && Warnings !== null && Warnings.length > 0">
            <li v-for="(warning, warningIndex) in Warnings" :key="warningIndex">{{warning}}</li>
        </ul>
        <h3 v-if="Report === null && Users !== null && Users.length > 0">Users To Import</h3>
        <table v-if="Report === null && Users !== null && Users.length > 0">
            <thead>
                <tr>
                    <th>
                        Email
                    </th>
                    <th>
                        Name
                    </th>
                    <th>
                        Organisation
                    </th>
                    <th>
                        Status
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(user, userIndex) in Users" :key="userIndex">
                    <td>
                        {{user.email}}
                    </td>
                    <td>
                        {{user.firstName}} {{user.lastName}}
                    </td>
                    <td>
                        {{user.organisationName}}
                    </td>
                    <td>
                        {{GetUserStatus(user)}}
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="Users !== null && Users.length > 0 && Report === null">
            <h2>User Setup</h2>
            <p>Select Companies:</p>
            <div v-for="(company, companyIndex) in Companies" :key="companyIndex">
                <label v-if="company.roles.length === 1"><input type="checkbox" :value="company.roles[0].id" v-model="AssignedRoles" /> {{company.roles[0].name}}</label>
                <strong v-if="company.roles.length > 1" style="cursor:pointer;padding-left:3px;" @click="expandCollapseCompany(company.name)">{{company.isExpanded ? "▼" : "▶"}} {{company.name}}</strong>
                <ul v-if="company.roles.length > 1 && company.isExpanded" style="margin:0">
                    <li v-for="(role, index) in company.roles" :key="role.id" style="list-style:none;"><label><input type="checkbox" :value="role.id" v-model="AssignedRoles" /><i style="font-weight:bold;" v-if="index ==0">All</i><span style="font-weight:bold;" v-else>{{role.name.split('~')[1]}}</span></label></li>
                </ul>
            </div>
            <h2>Email Templates</h2>
            <label>
                Welcome Email:
                <select v-model="WelcomeTemplate">
                    <option v-for="template in Templates.filter(function (t) {return t.type === 0;})" :key="template.emailTemplateId" :value="template.emailTemplateId">{{template.templateName}}</option>
                </select>
            </label> (<a href="#" @click="NewTemplate(['displayName', 'password'],0)">New Registration Template</a>)<br />
            <div v-if="WelcomeTemplate !== null">
                <label>Email From Alias: <span>{{WelcomeTemplateDetails.fromAlias}}</span></label>
                <label>Subject: <span>{{WelcomeTemplateDetails.templateSubject}}</span></label>
                <label>Body: <a href="#" @click="LoadBody(WelcomeTemplateDetails);">View</a></label>
                <hr />
            </div>
            <label>
                Process Existing Users:
                <select v-model="IgnoreAlreadyRegisteredUsers">
                    <option :value="false">Yes</option>
                    <option :value="true">No</option>
                </select>
            </label>
            <label v-if="!IgnoreAlreadyRegisteredUsers">
                Already Registered Email:
                <select v-model="AlreadyRegisteredTemplate">
                    <option v-for="template in Templates.filter(function (t) {return t.type === 1;})" :key="template.emailTemplateId" :value="template.emailTemplateId">{{template.templateName}}</option>
                </select>
            </label> <span v-if="!IgnoreAlreadyRegisteredUsers">(<a href="#" @click="NewTemplate(['displayName'],1)">New Already Registered Email Template</a>)<br /></span>
            <div v-if="!IgnoreAlreadyRegisteredUsers && AlreadyRegisteredTemplate !== null">
                <label>Email From Alias: <span>{{AlreadyRegisteredTemplateDetails.fromAlias}}</span></label>
                <label>Subject: <span>{{AlreadyRegisteredTemplateDetails.templateSubject}}</span></label>
                <label>Body: <a href="#" @click="LoadBody(AlreadyRegisteredTemplateDetails);">View</a></label>
                <hr />
            </div>
            <label>
                Reminder Email:
                <select v-model="ReminderTemplate">
                    <option v-for="template in Templates.filter(function (t) {return t.type === 2;})" :key="template.emailTemplateId" :value="template.emailTemplateId">{{template.templateName}}</option>
                </select>
            </label> (<a href="#" @click="NewTemplate(['displayName'],2)">New Reminder Email Template</a>)<br />
            <label v-if="ReminderTemplate !== null">
                Delay Before Sending:
                <select v-model="ReminderEmailDelayInHours">
                    <option value="24">1 Day</option>
                    <option value="48">2 Days</option>
                    <option value="36">3 Days</option>
                    <option value="168">7 Days</option>
                    <option value="336">14 Days</option>
                </select>
            </label><br />
            <div v-if="ReminderTemplate !== null">
                <label>Email From Alias: <span>{{ReminderTemplateDetails.fromAlias}}</span></label>
                <label>Subject: <span>{{ReminderTemplateDetails.templateSubject}}</span></label>
                <label>Body: <a href="#" @click="LoadBody(ReminderTemplateDetails);">View</a></label>
                <hr />
            </div>
            <h2>Email Subscriptions</h2>
            <h3>Adviser Software Email</h3>
            <label>Users yet to subscribe: <span>{{Users.filter(function(u){return u.asiEmailStatus === 0}).length }}</span></label><br>
            <label>Users already subscribed: <span>{{Users.filter(function(u){return u.asiEmailStatus === 1}).length }}</span></label><br>
            <label>Users unsubscribed: <span>{{Users.filter(function(u){return u.asiEmailStatus === 2}).length }}</span></label><br>
            <label>Users cleaned (previously subscribe but mailchimp received hard bounces): <span>{{Users.filter(function(u){return u.asiEmailStatus === 3}).length }}</span></label><br>
            <label>Users pending: <span>{{Users.filter(function(u){return u.asiEmailStatus === 4}).length }}</span></label><br>
            <label>
                Subscription to Email:
                <select v-model="ASIEmailRequirements">
                    <option value="Do not subscribe users">Do not subscribe users</option>
                    <option value="Subscribe users, if possible">Subscribe users, if possible</option>
                    <option value="Subscribe users and don't register users that cannot be subscribed">Subscribe users and don't register users that cannot be subscribed</option>
                </select>
            </label>
            <label v-if="ASIEmailRequirements !== 'Do not subscribe users'">
                Subscription Preference:
                <select v-model="ASIEmailPreference">
                    <option value="Changes when they take place">Changes when they take place</option>
                    <option value="End of the day update">End of the day update</option>
                    <option value="End of the week digest">End of the week digest</option>
                </select>
            </label>
            <h3>Benefits Guru Email</h3>
            <label>Users yet to subscribe: <span>{{Users.filter(function(u){return u.bgEmailStatus === 0}).length }}</span></label><br>
            <label>Users already subscribed: <span>{{Users.filter(function(u){return u.bgEmailStatus === 1}).length }}</span></label><br>
            <label>Users unsubscribed: <span>{{Users.filter(function(u){return u.bgEmailStatus === 2}).length }}</span></label><br>
            <label>Users cleaned (previously subscribe but mailchimp received hard bounces): <span>{{Users.filter(function(u){return u.bgEmailStatus === 3}).length }}</span></label><br>
            <label>Users pending: <span>{{Users.filter(function(u){return u.bgEmailStatus === 4}).length }}</span></label><br>
            <label>
                Subscription to Email:
                <select v-model="BGEmailRequirements">
                    <option value="Do not subscribe users">Do not subscribe users</option>
                    <option value="Subscribe users, if possible">Subscribe users, if possible</option>
                    <option value="Subscribe users and don't register users that cannot be subscribed">Subscribe users and don't register users that cannot be subscribed</option>
                </select>
            </label><br />
            <label v-if="BGEmailRequirements !== 'Do not subscribe users'">
                Subscription Preference:
                <select v-model="BGEmailPreference">
                    <option value="Changes when they take place">Changes when they take place</option>
                    <option value="End of the day update">End of the day update</option>
                    <option value="End of the week digest">End of the week digest</option>
                </select>
            </label>
            <h3>Protection Guru Email</h3>
            <label>Users yet to subscribe: <span>{{Users.filter(function(u){return u.pgEmailStatus === 0}).length }}</span></label><br>
            <label>Users already subscribed: <span>{{Users.filter(function(u){return u.pgEmailStatus === 1}).length }}</span></label><br>
            <label>Users unsubscribed: <span>{{Users.filter(function(u){return u.pgEmailStatus === 2}).length }}</span></label><br>
            <label>Users cleaned (previously subscribe but mailchimp received hard bounces): <span>{{Users.filter(function(u){return u.pgEmailStatus === 3}).length }}</span></label><br>
            <label>Users pending: <span>{{Users.filter(function(u){return u.pgEmailStatus === 4}).length }}</span></label><br>
            <label>
                Subscription to Email:
                <select v-model="PGEmailRequirements">
                    <option value="Do not subscribe users">Do not subscribe users</option>
                    <option value="Subscribe users, if possible">Subscribe users, if possible</option>
                    <option value="Subscribe users and don't register users that cannot be subscribed">Subscribe users and don't register users that cannot be subscribed</option>
                </select>
            </label>
            <label v-if="PGEmailRequirements !== 'Do not subscribe users'">
                Subscription Preference:
                <select v-model="PGEmailPreference">
                    <option value="Changes when they take place">Changes when they take place</option>
                    <option value="End of the day update">End of the day update</option>
                    <option value="End of the week digest">End of the week digest</option>
                </select>
            </label>
        </div>
        <button v-if="Report === null" @click="FinalImport" :title="CanImport === true ? null : CanImport" :disabled="CanImport !== true">Continue</button>
        <email-template-creator v-if="PlaceHolders !== null && NewEmailTemplateType !== null" @template-added="TemplateAdded" @cancel="CancelNewTemplate" :place-holders="PlaceHolders" :template-type="NewEmailTemplateType" />
        <h2 v-if="Report !== null">Import Report</h2>
        <div v-if="Report !== null" v-html="Report">
        </div>
    </fieldset>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import EmailTemplateCreator from './EmailTemplateCreator.vue';
    import $ from 'jquery';
    export default {
        name: 'BulkImport',
        components: { LoadingIndicator, EmailTemplateCreator },
        data: function () {
            return {
                PlaceHolders: null,
                NewEmailTemplateType: null,
                ASIEmailRequirements: "Do not subscribe users",
                ASIEmailPreference: "Changes when they take place",
                PGEmailRequirements: "Do not subscribe users",
                PGEmailPreference: "Changes when they take place",
                BGEmailRequirements: "Do not subscribe users",
                BGEmailPreference: "Changes when they take place",
                IgnoreAlreadyRegisteredUsers: false,
                AssignedRoles: [],
                IsLoading: false,
                Errors: null,
                Warnings: null,
                Users: null,
                ExpandedCompanies: [],
                Roles: [],
                Templates: [],
                WelcomeTemplate: null,
                AlreadyRegisteredTemplate: null,
                ReminderTemplate: null,
                ReminderEmailDelayInHours: 168,
                Report: null
            }
        },
        created: function () {
            var thisControl = this;
            $.ajax({
                type: 'GET',
                url: 'Roles/',
                dataType: 'json',
                success: function (data) {
                    thisControl.Roles = data;
                }

            });
            $.ajax({
                type: 'GET',
                url: '/api/BulkRegistration/Templates',
                dataType: 'json',
                success: function (data) {
                    thisControl.Templates = data;
                }

            });
        },
        methods: {

            FinalImport: function () {
                var thisControl = this;
                this.IsLoading = true;
                var importDetails = {

                    users: thisControl.Users,
                    rolestoAssign: thisControl.AssignedRoles,
                    pgemailRequirements: this.PGEmailRequirements,
                    pgemailPreference: this.PGEmailPreference,
                    bgemailRequirements: this.BGEmailRequirements,
                    bgemailPreference: this.BGEmailPreference,
                    asiemailRequirements: this.ASIEmailRequirements,
                    asiemailPreference: this.asiemailPreference,
                    reminderTemplateId: this.ReminderTemplate,
                    welcomeTemplateId: this.WelcomeTemplate,
                    alreadyRegisteredTemplateId: this.AlreadyRegisteredTemplate,
                    ReminderDelay: this.ReminderEmailDelayInHours,
                    ignoreAlreadyRegisteredUsers: this.IgnoreAlreadyRegisteredUsers
                };
                fetch(
                    "/api/BulkRegistration/Import",
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(importDetails),
                    }

                ).then(
                    function (response) {
                        return response.json();
                    }
                ).then(
                    function (data) {
                        thisControl.Report = data;
                        thisControl.IsLoading = false;
                    }
                ).catch(
                    function (error) {
                        alert("Error importing: " + error);
                        thisControl.IsLoading = false;
                    }
                )
            },
            CancelNewTemplate: function () {
                this.PlaceHolders = null;
                this.NewEmailTemplateType = null;
            },
            NewTemplate: function (newTemplatePlaceHolders, newTemplateType) {
                this.PlaceHolders = newTemplatePlaceHolders;
                this.NewEmailTemplateType = newTemplateType;
            },
            TemplateAdded: function () {
                var thisControl = this;

                $.ajax({
                    type: 'GET',
                    url: '/api/BulkRegistration/Templates',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.Templates = data;
                        thisControl.PlaceHolders = null;
                        thisControl.NewEmailTemplateType = null;
                    }

                });
            },
            LoadBody(template) {
                var newWin = window.open("about:blank", template.templateName);

                newWin.document.write(template.templateBody);
                return false;//prevent default behaviour on anchor...
            },
            expandCollapseCompany(company) {
                if (this.ExpandedCompanies.indexOf(company) === -1)
                    this.ExpandedCompanies.push(company)
                else
                    this.ExpandedCompanies.splice(this.ExpandedCompanies.indexOf(company), 1);
            },
            GetUserStatus: function (user) {
                if (this.PGEmailRequirements === "Subscribe users and don't register users that cannot be subscribed" && (user.pgEmailStatus === 3 || user.pgEmailStatus === 2))
                    return "Error";
                if (this.BGEmailRequirements === "Subscribe users and don't register users that cannot be subscribed" && (user.bgEmailStatus === 3 || user.bgEmailStatus === 2))
                    return "Error";
                if (this.ASIEmailRequirements === "Subscribe users and don't register users that cannot be subscribed" && (user.asiEmailStatus === 3 || user.asiEmailStatus === 2))
                    return "Error";
                if (user.isExisting)
                    return "Existing User";
                return "New User";
            },
            FileAdded: function (files) {
                var thisControl = this;
                if (files.length > 0) {
                    var file = files[0];
                    var formData = new FormData();
                    formData.append("spreadsheetFile", file);
                    this.IsLoading = true;
                    fetch(
                        "/api/BulkRegistration",
                        {
                            method: "POST",
                            body: formData
                        }
                    ).then(
                        function (response) {
                            return response.json();
                        }
                    ).then(
                        function (result) {
                            thisControl.IsLoading = false;
                            thisControl.Errors = result.errors;
                            thisControl.Warnings = result.warnings;
                            thisControl.Users = result.users;
                        }
                    ).catch(function (reason) {
                        alert(reason);
                    })
                }

            }
        },
        computed: {
            CanImport: function () {
                var thisControl = this;
                if (thisControl.Users === null)
                    return 'Users is null';
                if (thisControl.Users.filter(function (u) { return thisControl.GetUserStatus(u) !== 'Error'; }).length == 0)
                    return 'No non-erroring users';
                if (thisControl.AssignedRoles.length === 0)
                    return "No AssignedRoles";
                if (thisControl.ReminderTemplate === null)
                    return "ReminderTemplateNotSet";
                if (!this.IgnoreAlreadyRegisteredUsers && thisControl.AlreadyRegisteredTemplate === null)
                    return "AlreadyRegisteredTemplate not set";
                if (thisControl.WelcomeTemplate === null)
                    return "Welcome Template not set"
                return true;
            },
            WelcomeTemplateDetails: {
                get: function () {
                    var thisControl = this;
                    var matchingTemplates = this.Templates.filter(function (template) { return template.emailTemplateId === thisControl.WelcomeTemplate; });
                    if (matchingTemplates.length > 0)
                        return matchingTemplates[0];
                    return null;
                }
            },
            AlreadyRegisteredTemplateDetails: {
                get: function () {
                    var thisControl = this;
                    var matchingTemplates = this.Templates.filter(function (template) { return template.emailTemplateId === thisControl.AlreadyRegisteredTemplate; });
                    if (matchingTemplates.length > 0)
                        return matchingTemplates[0];
                    return null;
                }
            },
            ReminderTemplateDetails: {
                get: function () {
                    var thisControl = this;
                    var matchingTemplates = this.Templates.filter(function (template) { return template.emailTemplateId === thisControl.ReminderTemplate; });
                    if (matchingTemplates.length > 0)
                        return matchingTemplates[0];
                    return null;
                }
            },
            Companies: function () {
                if (this.Roles == null)
                    return null;
                var result = [];
                var company = null;
                for (var r = 0; r < this.Roles.length; r++) {
                    var role = this.Roles[r];
                    if (role.name.indexOf("~") == -1) {
                        company = {
                            roles: [role],
                            name: role.name,
                            isExpanded: this.ExpandedCompanies.indexOf(role.name) === -1 ? false : true
                        };
                        result.push(company);
                    }
                    else {
                        company.roles.push(role);
                    }
                }
                return result;
            },
        }
    }
</script>
